import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type Props = {
  title: ReactNode | string;
  children?: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
  width?: number;
};

export const SelectableCard = ({
  width = 350,
  title,
  children,
  isSelected = false,
  onClick,
  'data-testid': dataTestId,
}: Props) => {
  return (
    <Stack
      data-testid={dataTestId}
      sx={[
        {
          border: 1,
          borderRadius: 3,
          maxWidth: width,
          minWidth: width,
          width: width,
        },
        (theme) => ({
          borderColor: isSelected ? theme.palette.primary.main : theme.palette.border.main,
        }),
      ]}
    >
      <Stack
        direction="row"
        sx={[
          {
            alignItems: 'center',
            borderRadius: 3,
            justifyContent: 'center',
            padding: 2,
          },
          (theme) => ({
            background: isSelected ? theme.palette.primary[100] : theme.palette.background.default,
            borderBottom: 1,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderColor: isSelected ? theme.palette.primary.main : theme.palette.border.main,
          }),
        ]}
      >
        <Checkbox onClick={onClick} checked={isSelected} />{' '}
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};
